import { DateField, TextField, TimeField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TravelSegmentFormValues } from "../../../../../shared/types/travelSegment";

export const emptyTrainFormValues = (): TravelSegmentFormValues => ({
	id: Symbol("train"),
	type: "train",
	arrivalLocation: "",
	departureDate: "",
	departureTime: "",
	arrivalDate: "",
	arrivalTime: "",
	departureLocation: "",
	serviceClass: "",
	identifier: "",
	additionalIdentifiers: [],
});
export const TravelSegmentTrainFormFields: FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<TextField name="departureLocation" label={t("Departure station")} required />
			<DateField name="departureDate" label={t("Departure date")} required />
			<TimeField name="departureTime" label={t("Departure time")} required />
			<TextField name="arrivalLocation" label={t("Arrival station")} required />
			<DateField name="arrivalDate" label={t("Arrival date")} required />
			<TimeField name="arrivalTime" label={t("Arrival time")} required />
			<TextField name="identifier" label={t("Train number")} />
			<TextField name="serviceClass" label={t("Service class")} />
		</>
	);
};
